var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-breadcrumbs",
      attrs: {
        itemscope: "itemscope",
        itemtype: "http://schema.org/BreadcrumbList",
        role: "navigation",
        "aria-labelledby": "breadcrumbs-<?php echo $id = uniqid('id') ?>"
      }
    },
    [
      _vm.isLabelVisible
        ? _c(
            "strong",
            {
              staticClass: "c-breadcrumbs__label",
              attrs: { id: "breadcrumbs-<?php echo $id ?>" }
            },
            [_vm._v("\n\t\t\t" + _vm._s(_vm.label) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.items, function(item, key) {
        return [
          _c(
            "span",
            {
              attrs: {
                itemprop: "itemListElement",
                itemscope: "itemscope",
                itemtype: "http://schema.org/ListItem"
              }
            },
            [
              item.isRouterLink
                ? _c("router-link", { attrs: { to: item.url } }, [
                    _vm._v(_vm._s(item.name))
                  ])
                : _c(
                    "a",
                    {
                      staticClass: "c-breadcrumbs__link",
                      attrs: { itemprop: "item", href: item.url }
                    },
                    [
                      _c("span", { attrs: { itemprop: "name" } }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ]
                  ),
              _vm._v(" "),
              _c("meta", { attrs: { itemprop: "position", content: key } })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "c-breadcrumbs__separator" }, [
            _vm._v(" / ")
          ])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }